module.exports = "/dist/img/giftshopper_fabric6.68c61e28.jpg";